// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var switchRecordNil = function (dictTypeEquals) {
    return {
        switchRecord: function (v) {
            return function (v1) {
                return Type_Equality.to(dictTypeEquals)({});
            };
        }
    };
};
var switchRecord = function (dict) {
    return dict.switchRecord;
};
var switchRecordI = function (dictSwitchRecord) {
    return function () {
        return {
            "switch": switchRecord(dictSwitchRecord)(Type_Proxy["Proxy"].value)
        };
    };
};
var switchFinal = {
    "switch": /* #__PURE__ */ (function () {
        var $17 = Control_Bind.join(Specular_FRP_Base.bindDynamic);
        var $18 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
            return v;
        });
        return function ($19) {
            return Restaumatic_Form_Final.Final(Data_Functor_Compose.Compose($17($18($19))));
        };
    })()
};
var switchEvent = {
    "switch": Specular_FRP_Base["switch"]
};
var switchEffect = {
    "switch": /* #__PURE__ */ (function () {
        var $20 = Control_Bind.join(Effect.bindEffect);
        var $21 = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
        return function ($22) {
            return $20($21($22));
        };
    })()
};
var switchDynamic = {
    "switch": /* #__PURE__ */ Control_Bind.join(Specular_FRP_Base.bindDynamic)
};
var $$switch = function (dict) {
    return dict["switch"];
};
var switchFunction = function (dictSwitch) {
    return {
        "switch": function (f) {
            return function (x) {
                return $$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                    return v(x);
                })(f));
            };
        }
    };
};
var switchRecordCons = function (dictIsSymbol) {
    return function () {
        return function () {
            return function (dictSwitch) {
                return function (dictSwitchRecord) {
                    return function () {
                        return {
                            switchRecord: function (v) {
                                return function (dyn) {
                                    return Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)($$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value))(dyn)))(switchRecord(dictSwitchRecord)(Type_Proxy["Proxy"].value)(dyn));
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var switchRef = {
    "switch": function (dyn) {
        return new Specular_Ref.Ref($$switch(switchDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.value)(dyn)), $$switch(switchFunction(switchEffect))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.modify(Effect_Class.monadEffectEffect))(dyn)));
    }
};
var dynamicSwitch = function (dictSwitch) {
    return function (dictMonadReplace) {
        return function (dictMonadFRP) {
            var $23 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())($$switch(dictSwitch));
            var $24 = Specular_FRP_Replaceable.dynamic(dictMonadReplace)(dictMonadFRP);
            return function ($25) {
                return $23($24($25));
            };
        };
    };
};
export {
    $$switch as switch,
    dynamicSwitch,
    switchRecord,
    switchDynamic,
    switchEvent,
    switchEffect,
    switchFunction,
    switchRef,
    switchFinal,
    switchRecordI,
    switchRecordNil,
    switchRecordCons
};
//# sourceMappingURL=index.js.map
